module.exports = __webpack_public_path__ + "static/media/qr-step1.e1bd2e60.svg";